import SERVICES_API_V1 from 'api/services/v1'
import { useCallback, useState } from 'react'

export const useGetAccountLogin = (networkId) => {
  const [loadingLogin, setLoadingLogin] = useState(true)

  const getAccountLogin = useCallback(() => {
    setLoadingLogin(true)

    return SERVICES_API_V1.generateLogin({ params: { network_id: networkId } })
      .then(({ response: { data } }) => {
        const { edit_type, prefix, postfix } = data

        setLoadingLogin(false)

        switch (edit_type) {
          case 'fully_editable':
            return {
              postfix: prefix + postfix,
              prefix: '',
              disabled: false,
            }
          case 'postfix_editable':
            return {
              postfix: postfix,
              prefix: prefix,
              disabled: false,
            }
          case 'not_editable':
            return {
              postfix: prefix + postfix,
              prefix: '',
              disabled: true,
            }
        }
      })
      .catch(() => ({ disabled: true, postfix: '', prefix: '' }))
  }, [networkId])

  return { loadingLogin, getAccountLogin }
}
